import React from 'react'
import './CallforPapers.css'
const CallforPapers = () => {
    return (
        <div className="CallforPapers">
            <h1 className="cfp">Call for papers</h1>
            <ol>
                <h3 className="tite"><i className="fa-solid fa-hand-point-right"></i> Computer engineering</h3>
                <ul className="liste">
                    <li>Intelligent Computing</li>
                    <li>Database Management Systems</li>
                    <li> Software Engineering</li>
                    <li>Systems Software</li>
                    <li> Data Communication and Networking</li>
                    <li>Internet of Things</li>
                    <li>Management Information System</li>
                    <li>Artificial Intelligence</li>
                    <li>Bio Inspired Computing</li>
                    <li>Bioinformatics</li>
                    <li>Computer Vision</li>
                    <li>Expert Systems</li>
                    <li>Image Processing</li>
                    <li>Information Retrieval and Fusion</li>
                    <li>Big Data</li>
                    <li>Data Engineering</li>
                    <li>Data Mining</li>
                    <li>Data Warehousing</li>
                    <li>Compiler Design</li>
                    <li>Computer System and Modeling operating System</li>
                    <li>Parallel and Distributed Computing</li>
                    <li>Emerging Trends in Information Technology and Business Analytics</li>
                    <li>Internet Addiction</li>
                    <li>Blockchain the Future Technology</li>
                    <li>Applications of Artificial Intelligence and Machine Learning</li>
                    <li>Remote Management of Technology Infrastructure</li>
                    <li>Financial Informatics</li>
                    <li>Business Process Optimization</li>
                    <li>Gamification Technologies, Neuromarketing VR, AR and Mixed Reality</li>
                    <li>Time Series Forecasting</li>
                    <li>Algorithmic Trading</li>
                    <li>Big Data Analytics</li>
                </ul>
                <h3 className="tite"><i className="fa-solid fa-hand-point-right"></i> Electrical and Electronics</h3>

                <ul className="liste">
                    <li>Advanced Control Strategies in Electric Vehicle</li>
                    {/* <li>Smart grid, Micro grid and demand response</li> */}
                    <li>Smart Grid and Distributed Generation</li>
                    {/* <li>Advanced metering instrumentation and communication system</li>
                    <li>New advance in energy storage technologies like battery, Ultra Capacitors, Super Magnetic</li> */}
                    {/* <li>Energy Storage Systems,</li>
                    <li>Real time distribution simulation</li> */}
                    {/* <li>Renewable Energy Sources</li> */}
                    <li>Intelligent Power Electronic Systems</li>
                    <li>Sustainable Energy and Reduction in Carbon Footprint-Associated Studies</li>
                    <li>Advanced Material for Photo voltaic Cells</li>
                    <li>Power Quality Issues and Mitigation Techniques</li>
                    {/* <li>Distribution loss estimation techniques and simulation tools with case studies</li>
                    <li>Grid integration of Renewable energy System Power quality and mitigation techniques</li> */}
                    <li>FACTS, HVDC, Custom Power devices</li>
                    <li>   High Voltage & Power Engineering
                        Applications</li>
                    <li>Energy Management</li>
                    <li>Hybrid EV, Plug-In Hybrid EV & Fuel
                        Cell EV</li>
                    <li>Vehicle to Grid, Vehicle to Building/
                        Critical Loads</li>
                    <li>EMI & EMC Studies</li>
                    <li>Distribution Automation, Advance
                        Monitoring & Cyber Security</li>
                    <li>Grid Reliability, Resilience – New
                        Advances</li>
                </ul>
                <h3 className="tite"><i className="fa-solid fa-hand-point-right"></i> Electronics and Communication</h3>

                <ul className="liste">
                    <li>Signal Processing</li>
                    <li>VLSI Design</li>
                    <li> Antenna Engineering</li>
                    <li>Photonic/ Opto Electronic Structures / Devices</li>
                    <li>Nanophotonics</li>
                    <li>Consumer Electronics</li>
                    <li>Smart Electronics Systems</li>
                    <li>Low Power VLSI Circuits & Mixed Mode VLSI</li>
                    <li>Satellite Communication</li>
                    <li>VLSI Verification and Testing</li>
                    <li>Robotics and automation</li>
                    {/* <li>Internet of Things</li> */}
                    <li> Next Generation Networks</li>
                    <li>Optical and Photonic Networks</li>
                    <li> Spread Spectrum Communication</li>
                    <li>Sensors & Networks</li>
                    <li>Embedded Systems</li>
                    <li>Communication Systems</li>
                    <li>Quantum Computing</li>
                    <li>VLSI & VHDL Design & applications</li>
                    <li>Vehicular Communication Techniques</li>
                    <li>MEMS & Medical Electronics
</li>
                </ul>
            </ol>
        </div>
    )
}

export default CallforPapers